import { render, staticRenderFns } from "./navbarConfig.vue?vue&type=template&id=202d35ae&scoped=true"
import script from "./navbarConfig.vue?vue&type=script&lang=js"
export * from "./navbarConfig.vue?vue&type=script&lang=js"
import style0 from "./navbarConfig.vue?vue&type=style&index=0&id=202d35ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d35ae",
  null
  
)

export default component.exports